<template>
  <div v-if="accommodationObject" id="accounts-select">
    <e-select
      :model-value="selectedData"
      :items="objects"
      :readonly="!accommodationObject?.contracts.length"
      item-title="title"
      item-value="contractNumber"
      menu-cover
      @update:model-value="selectAccount"
    >
      <template #selection="{ item }">
        <div>
          <div>
            {{ item.title }}
          </div>
          <div v-if="item.raw.contractNumber" class="d-flex paragraph-xs mt-1">
            <div class="mr-2">Аккаунт {{ item.raw.contractNumber }}</div>
            <account-status :status="item.raw.status" size="M" />
          </div>
        </div>
      </template>

      <template #item="{ item }">
        <template v-if="item.raw.contractNumber">
          <div v-if="item.raw.contractNumber" class="d-flex flex-wrap align-center paragraph-s">
            <b class="mr-2 mb-1">{{ item.raw.contractNumber }}</b>
            <account-status :status="item.raw.status" size="M" class="mb-1" />
          </div>
          <div class="paragraph-xs">{{ item.raw.name }}</div>
          <div class="d-flex paragraph-xs mt-1">
            Оплата туроператором
            <vertical-line class="ml-2 mr-2" />
            <b>{{ getCurrencyText(item.raw.currency) }}</b>
          </div>
        </template>
      </template>
    </e-select>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import VerticalLine from '@/core/components/helpers/VerticalLine.vue';
import { ESelect } from '@/core/components/ui';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { getCurrencyText } from '@/core/utils/currency';
import { ContractStatus } from '@/graphql/generated';
import AccountStatus from '@/parts/objects/components/AccountStatus.vue';
import { useAccommodationObjectsStore } from '@/parts/objects/store/accommodationObjects';

const $router = useRouter();
const $route = useRoute();

const { activeAccount, accommodationObject } = useAccommodationObjectsStore();

type AccountType = {
  title: string | undefined;
  name: string;
  contractNumber: number;
  currency: string;
  status: ContractStatus;
};

const selectAccount = (contractNumber: number | null | undefined) => {
  if (!contractNumber) {
    return;
  }

  $router.push({
    name: RouteNames.ObjectInfo,
    params: { id: $route.params.id, acc_id: contractNumber },
  });
};

const selectedData = toRef<() => number>(() => activeAccount.value?.contractNumber || 0);

const objects = toRef<() => AccountType[]>(() =>
  accommodationObject.value?.contracts?.length
    ? accommodationObject.value.contracts.map((contract) => ({
        title: accommodationObject.value?.commonInformation?.name[0].value,
        name: contract.legal.name[0].value,
        contractNumber: contract.contractNumber as number,
        currency: contract.currencyISOCode,
        status: contract.status,
      }))
    : [
        {
          title: accommodationObject.value?.commonInformation?.name[0].value,
          contractNumber: 0,
          name: '',
          currency: '',
          status: ContractStatus.OnApproval,
        },
      ],
);
</script>

<style scoped lang="scss"></style>
